import * as bootstrap from 'bootstrap';
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"
import GLightbox from 'glightbox';
import Swiper from 'swiper/bundle';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.initGLightbox();
        this.bookingForm();
        this.cardCarousel();
        this.cookies();
        this.counter();
        this.dropdowns();
        this.datePickers();
        this.progressBars();
        this.responsiveTables();
        this.responsiveEmbeds();
    }

    initGLightbox() {
        GLightbox({
            zoomable: true
        });
    }

    bookingForm() {
        const formBooking = document.getElementById('form-booking');

        if (formBooking === null) {
            return false;
        }

        formBooking.addEventListener('submit', function (e) {
            e.preventDefault();

            const checkinDate   = this.querySelector('[name="checkin"]').value;
            const checkoutDate  = this.querySelector('[name="checkout"]').value;
            const adults        = this.querySelector('[name="adults"]').value;
            const children      = this.querySelector('[name="children"]').value;

            if (!checkinDate || !checkoutDate) {
                alert('Selecteer eerst een in- en uitcheckdatum.');

                return false;
            }

            const baseUrl = config.bookingUrl;

            const [dayIn, monthIn, yearIn] = checkinDate.split('-');
            const [dayOut, monthOut, yearOut] = checkoutDate.split('-');

            const formattedCheckin = `${yearIn}-${monthIn}-${dayIn}`;
            const formattedCheckout = `${yearOut}-${monthOut}-${dayOut}`;

            const url = `${baseUrl}?checkin=${formattedCheckin}&checkout=${formattedCheckout}&adults=${adults}&children=${children}`;

            // Open the booking URL in a new tab
            window.open(url, '_blank', 'noopener');
        });
    }

    cardCarousel() {
        document.querySelectorAll('.cards-slider__swiper').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('.cards-slider__swiper-wrapper').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                navigation: {
                    prevEl: element.parentElement.querySelector('.cards-slider__swiper-nav-arrow--prev'),
                    nextEl: element.parentElement.querySelector('.cards-slider__swiper-nav-arrow--next')
                },
                pagination: paginationOptions,
                spaceBetween: 20,
                autoplay: false,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 3
                    }
                },
                slidesPerGroup: 1
            });
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    counter() {
        const counters = document.querySelectorAll('.stats__item-counter');

        const formatNumber = (num) => {
            return num.toLocaleString('nl-NL'); // Formats as "4.000" using dot
        };

        const animateCount = (el, start, target) => {
            const duration = el.dataset.duration || 1500;

            const startTime = performance.now();

            const update = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const current = Math.floor(start + (target - start) * progress);

                el.textContent = formatNumber(current);

                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            };

            requestAnimationFrame(update);
        };

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const start = parseInt(el.dataset.start || 0, 10);
                    const target = parseInt(el.dataset.target, 10);

                    animateCount(el, start, target);

                    observer.unobserve(el); // Animate only once
                }
            });
        }, { threshold: 0.5 });

        counters.forEach(counter => {
            observer.observe(counter);
        });
    }

    dropdowns() {
        document.querySelectorAll('.dropdown').forEach(dropdown => {
            const dropdownToggle = dropdown.querySelector('.dropdown-toggle');

            dropdownToggle.addEventListener('show.bs.dropdown', event => {
                dropdown.classList.add('show');
            });

            dropdownToggle.addEventListener('hide.bs.dropdown', event => {
                dropdown.classList.remove('show');
            });
        });
    }

    /**
     * Initialize the date picker plugin
     */
    datePickers (container = document) {
        let inputCheckout = document.getElementById('checkout'), checkoutPicker = null;

        // Initialize date picker
        container.querySelectorAll('.datepicker').forEach(input => {
            let defaultDate = new Date();

            if (input.value.length) {
                // Split the string into parts
                let dateParts = input.value.split('-');

                // Use the parts to create a Date object
                defaultDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            }

            const instance = flatpickr(input, {
                minDate: input.dataset.minDate || 'today',
                defaultDate: defaultDate || 'today',
                dateFormat: 'd-m-Y',
                locale: Dutch,
                onChange: function (selectedDates) {
                    if (input.id === 'checkin' && selectedDates.length > 0 && inputCheckout) {
                        const checkoutDate = new Date(selectedDates[0]);
                        checkoutDate.setDate(checkoutDate.getDate() + 1);

                        checkoutPicker.set('minDate', checkoutDate);
                        checkoutPicker.setDate(checkoutDate);
                    }
                }
            });

            if (input.id === 'checkout') {
                // Save flatpickr instance
                checkoutPicker = instance;
            }

            // Prevent key presses
            input.addEventListener('keypress', function (e) {
                e.preventDefault();
            });
        });
    }

    progressBars() {
        const progressBars = document.querySelectorAll('.progress-bar');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const bar = entry.target;
                    const text = bar.querySelector('.text');
                    const target = parseInt(bar.dataset.target, 10);

                    bar.style.transition = 'width 1s ease';
                    bar.style.width = `${target}%`;
                    bar.setAttribute('aria-valuenow', target);

                    text.innerText = `${target}%`;

                    observer.unobserve(bar); // Optional: animate only once
                }
            });
        }, { threshold: 0.5 });

        progressBars.forEach(bar => {
            observer.observe(bar);
        });
    }

    responsiveTables() {
        // Responsive embeds
        document.querySelectorAll('table:not([class])').forEach(table => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'table-responsive');

            Helper.wrap(table, wrapper);
        });
    }

    responsiveEmbeds() {
        // Responsive embeds
        document.querySelectorAll('iframe:not([class])').forEach(iframe => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'ratio ratio-16x9');

            Helper.wrap(iframe, wrapper);
        });
    }
}

window.addEventListener('load', () => {
    new App();

    // Remove loading class from body
    document.body.classList.remove('loading');
});
